<template>
	<v-expansion-panel class="panel-stepper-sale">
		<v-expansion-panel-header
			:disabled="isDisabled"
			:class="`header-stepper-sale ${addClassHeaderOnDisabled} ${addClassHeaderOnActive} ${addClassHeaderOnLastPanel}`"
		>
			<h4 class="font-weight-bold"><slot name="header"></slot></h4>
			<template v-slot:actions>
				<v-icon :color="`${addClassHeaderIconOnActive}`"> {{ !isDisabled ? '$expand' : '' }} </v-icon>
			</template>
		</v-expansion-panel-header>
		<v-expansion-panel-content :class="`panel-content-sale ${addClasContentOnLastPanel}`" id="expansion-panel">
			<v-container class="pt-3">
				<slot name="content"></slot>
			</v-container>
		</v-expansion-panel-content>
	</v-expansion-panel>
</template>

<script>
export default {
	props: {
		activePanel: {
			type: Number,
			default: null
		},
		panelKey: {
			type: Number,
			required: true
		},
		isDisabled: {
			type: Boolean,
			default: false
		},
		isLastPanel: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		isActivePanel() {
			return this.activePanel === this.panelKey;
		},
		addClassHeaderOnActive() {
			return this.isActivePanel ? 'header-stepper-sale-active' : '';
		},
		addClassHeaderOnDisabled() {
			return this.isDisabled ? 'header-stepper-sale-disable' : '';
		},
		addClassHeaderOnLastPanel() {
			return this.isLastPanel && !this.isActivePanel ? 'last-panel-content-sale' : '';
		},
		addClasContentOnLastPanel() {
			return this.isLastPanel && this.isActivePanel ? 'last-panel-content-sale' : '';
		},
		addClassHeaderIconOnActive() {
			return this.isActivePanel ? 'white' : '';
		}
	}
};
</script>

<style>
.header-stepper-sale-active {
	background-color: #575e60 !important;
	color: white !important;
	border: 0.5px solid #575e60 !important;
}

.panel-content-sale {
	border: 0.5px solid #d2d7d9;
	padding-left: 0px;
}

.panel-content-sale .v-expansion-panel-content__wrap {
	padding: 0 0px 16px !important;
}

.panel-stepper-sale {
	position: static !important;
	margin-top: 0px !important;
}

.header-stepper-sale {
	height: 70px;
	background-color: #f3f5f5;
	color: #293133;
	border: 0.5px solid #d2d7d9;
}

.header-stepper-sale-disable {
	color: #868c8d;
}

.last-panel-content-sale {
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
}
</style>
